import axios from "axios";
import { setConnections } from "../Data/dataStore";

const URL = "http://localhost:3000/dev/starred";
const GET_CONNECTION_URL = "http://localhost:3000/dev/connections";
const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;

// Fetch connections based on UserID with pagination
export const getConnections = async (UserID, page = 1, limit = 9, pageAll = 1, limitAll = 12) => {
  try {
    const response = await axios.get(`${dyrectApi}connections?UserID=${UserID}&page=${page}&limit=${limit}&pageAll=${pageAll}&limitAll=${limitAll}`);
    if (response?.data) {
      const { starredConnections = [], nonStarredConnections = [], allConnections = [] } = response.data;
      setConnections({
        starredConnections,
        nonStarredConnections,
        allConnections: allConnections.length > 0 ? allConnections : [...starredConnections, ...nonStarredConnections]
      });
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching connections:", error);
    throw error;
  }
};

// Update the starred status of a connection
export const updateStarredStatus = async (StarredUser, Starred, StarredBy) => {
  try {
    const response = await axios.put(`${dyrectApi}starred`, {
      UserID2: StarredUser,
      Starred: Starred === 1 ? true : false,
      UserID1: StarredBy
    });
    console.log("Starred status updated", response);
    return response.data;
  } catch (error) {
    console.error("Error updating starred status:", error);
    throw error;
  }
};

export const getPendingConnections = async () => {
  try {
    const response = await axios.get(`${dyrectApi}connections?UserID=${localStorage.getItem('user_id')}&Status=PENDING`);
    return response;
  } catch (error) {
    console.error("Error fetching connections:", error);
    throw error;
  }
}

export const logNewUnreadMessage = async (receiverId) => {
  const payload={
    receiverId: receiverId,
    senderId: localStorage.getItem('user_id')
  }
  try {
    console.log("inside the logNewUnreadMessage function", payload);
    const response = await axios.post(`${dyrectApi}message/queue`, payload);
    return response;
  } catch (error) {
    console.error("Error logging unread message:", error);
    throw error;
  }
}

